import { render } from "./Stripe.vue?vue&type=template&id=a4a974e2"
import script from "./Stripe.vue?vue&type=script&lang=js"
export * from "./Stripe.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a4a974e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4a974e2', script)) {
    api.reload('a4a974e2', script)
  }
  
  module.hot.accept("./Stripe.vue?vue&type=template&id=a4a974e2", () => {
    api.rerender('a4a974e2', render)
  })

}

script.__file = "src/icons/components/logos/Stripe.vue"

export default script